var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDev)?_c('div',{style:({
    position: 'fixed',
    width: '100%',
    zIndex: 100,
    padding: '10px',
    textAlign: 'center',
    pointerEvents: 'none',
  })},_vm._l((_vm.$i18n.locales),function(locale){return _c('t-button',{key:locale.code,style:({ pointerEvents: 'auto' }),attrs:{"type":locale.code === _vm.$i18n.locale ? 'danger' : 'simple'},on:{"click":function($event){return _vm.$i18n.setLocale(locale.code)}}},[_vm._v(_vm._s(locale.code))])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }